var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNoteHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_note_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.152,5.83333333 L8.08266667,5.83333333 C7.35466667,5.83333333 6.90666667,5.36666667 6.90666667,4.60833333 L6.90666667,0.466666667 C6.90666667,0.204166667 6.71066667,0 6.45866667,0 L2.744,0 C2.016,0 1.4,0.641666667 1.4,1.4 L1.4,12.6 C1.4,13.3583333 2.016,14 2.744,14 L11.256,14 C11.984,14 12.6,13.3583333 12.6,12.6 L12.6,6.3 C12.6,6.0375 12.404,5.83333333 12.152,5.83333333 Z M8.98816568,0.100961538 C8.92189349,0.0336538462 8.78934911,0 8.68994083,0 C8.49112426,0 8.29230769,0.168269231 8.29230769,0.370192308 L8.29230769,3.23076923 C8.29230769,3.83653846 8.82248521,4.375 9.41893491,4.375 L12.235503,4.375 C12.4343195,4.375 12.6,4.17307692 12.6,3.97115385 C12.6,3.87019231 12.5668639,3.73557692 12.5005917,3.66826923 L8.98816568,0.100961538 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_note_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_note-copy-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L14,0 L14,14 L0,14 L0,0 Z",
    id: "Rectangle-Copy-4",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#5697B7",
    xlinkHref: "#path-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoteHover);
export default __webpack_public_path__ + "static/media/icon_note_hover.0158fe3aa53d25bb97beb3d700d23c7e.svg";
export { ForwardRef as ReactComponent };